import React from 'react';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';

export const SolutionPhase = ({ phase, phaseIndex, solutionId, expandedPhases, setExpandedPhases }) => {
  if (!phase) return null;
  const phaseKey = `${solutionId}-${phase.id}`;
  const isExpanded = !!expandedPhases[phaseKey];

  return (
    <div className="border-b border-gray-100 last:border-0">
      <div
        className="flex items-center justify-between p-3 cursor-pointer hover:bg-gray-50 transition-colors"
        onClick={e => {
          e.stopPropagation();
          setExpandedPhases(prev => ({
            ...prev,
            [phaseKey]: !prev[phaseKey]
          }));
        }}
      >
        <h4 className="font-medium text-gray-900" style={{ marginBottom: 0 }}>
          <span className="inline-flex items-center px-2 py-0.5 rounded-full text-sm font-medium bg-gray-100 text-gray-700 mr-2">
            {`Phase ${phaseIndex + 1}`}
          </span>
          <span className="text-sm font-medium">
            {phase.objective && String(phase.objective).trim() ? phase.objective : 'Untitled phase'}
          </span>
        </h4>
        {isExpanded ? (
          <IconChevronUp className="text-gray-400" size={20} />
        ) : (
          <IconChevronDown className="text-gray-400" size={20} />
        )}
      </div>
      {isExpanded && (
        <div className="pl-11 pr-3 pb-3">
          {phase.tasks && phase.tasks.length > 0 ? (
            <ul className="space-y-2">
              {phase.tasks.map((task, taskIdx) => {
                const taskKey = `${solutionId}-task-${task.id}`;
                const isTaskExpanded = !!expandedPhases[`${taskKey}-expanded`];

                return (
                  <li key={taskKey} className="p-2 rounded hover:bg-gray-50">
                    <div className="flex items-start gap-3">
                      <span style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 24,
                        height: 24,
                        borderRadius: '50%',
                        background: '#E5E7EB',
                        color: '#374151',
                        fontWeight: 600,
                        fontSize: 14,
                        marginRight: 8
                      }}>{taskIdx + 1}</span>

                      <div className="flex-1">
                        {task.title && task.title.trim() ? (
                          <div
                            className="font-semibold text-sm text-gray-900 cursor-pointer hover:text-green-600 transition-colors flex items-center justify-between"
                            onClick={(e) => {
                              e.stopPropagation();
                              setExpandedPhases(prev => ({
                                ...prev,
                                [`${taskKey}-expanded`]: !prev[`${taskKey}-expanded`]
                              }));
                            }}
                          >
                            {task.title}
                            {task.content && task.content.trim() && (
                              <IconChevronDown className={`ml-2 text-gray-500 transition-transform ${isTaskExpanded ? 'rotate-180' : ''}`} size={14} />
                            )}
                          </div>
                        ) : null}

                        {task.content && task.content.trim() && (
                          <div className={`text-sm text-gray-700 ${task.title && task.title.trim() ? (isTaskExpanded ? 'mt-2' : 'hidden') : ''} ${task.completed ? 'line-through text-gray-400' : ''}`}>
                            {task.content}
                          </div>
                        )}

                        {(!task.title || !task.title.trim()) && (!task.content || !task.content.trim()) && (
                          <span className="text-sm text-gray-500 italic">Untitled task</span>
                        )}
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          ) : (
            <div className="py-2 text-sm text-gray-500 italic">
              No tasks defined for this phase.
            </div>
          )}
        </div>
      )}
    </div>
  );
};
